<template>
    <div id="app_index">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class="carousel">
                <swiper style="border-radius:0.3rem;" :options="swiperOption" ref="mySwiper">
                    <swiper-slide v-for="(item,index) in pageData.banners" :key='index'>
                        <router-link v-if="item.link_url.indexOf(root_url)>-1" :to="item.link_url.replace(root_url,'')"><img class="carsousel_img" :src="item.image_url" :alt="item.title" ></router-link>
                        <a v-else-if="item.link_url" :href="item.link_url"><img class="carsousel_img" :src="item.image_url" :alt="item.title" ></a>
                        <img v-else class="carsousel_img" :src="item.image_url" :alt="item.title" >
                    </swiper-slide>
                </swiper>
                <div class="swiper-pagination"></div>
            </div>
            <div class="center_content">
                <router-link class="center_left center_part" to="/subjectChoose/0">
                    <img class="teacher_img" src="./img/teacher.png" alt="">
                    <div class="part_text">布置作业</div>
                    <button class="pub_btn">点击布置 ></button>
                </router-link>
                <div class="center_right">
                    <router-link class="center_part" style="background-color:#57a0fe;" to="/tea/taskList">
                        <div class="part_text">检查作业</div>
                        <div class="part_label">{{ pageData.uncheck }}条作业待检查</div>
                        <img class="part_icon" src="./img/check.png" alt="">
                    </router-link>
                    <router-link class="center_part" style="background-color:#fe8781;" to="/communication/noticelist">
                        <div class="part_text">家校沟通</div>
                        <img class="part_icon" src="./img/school.png" alt="">
                    </router-link>
                    <a class="center_part" style="background-color:#ffc732;" :href="kz_root+'/mobile/subject?tbkt_token='+token">
                        <div class="part_text">课堂备课</div>
                        <img class="part_icon" src="./img/computer.png" alt="">
                    </a>
                </div>
            </div>
            <div class="statistics_part">
                <div class="part_title">本月教学统计</div>
                <div class="unit_lists">
                    <template v-for="s in pageData.task_num_new">
                        <div class="unit_item" v-for="u in s.data" :key="u.unit_class_id">
                            <img class="unit_icon" src="./img/unit_icon.png" alt="">
                            <div class="unit_info">
                                <div class="unit_name">{{ u.unit_name }}</div>
                                <div class="pub_line">作业已发 {{ u.real_task_count }} 次</div>
                                <div class="pub_line">通知已发 {{ u.real_mes_count }} 次</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="tea_cover" v-if="pageData.modal_show">
                <div class="active_modal">
                    <router-link v-if="pageData.modal.link_url.indexOf(root_url)>-1" :to="pageData.modal.link_url.replace(root_url,'')"><img class="carsousel_img" :src="pageData.modal.image_url" :alt="pageData.modal.title" ></router-link>
                    <a v-else-if="pageData.modal.link_url" :href="pageData.modal.link_url"><img class="carsousel_img" :src="pageData.modal.image_url" :alt="pageData.modal.title" ></a>
                    <img v-else class="carsousel_img" :src="pageData.modal.image_url" :alt="pageData.modal.title" >
                    <div class="modal_close" @click="pageData.modal_show=false"></div>
                </div>
            </div>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
    import loadings from "COMPONENTS/base/loadingS.vue";
    import 'swiper/css/swiper.css'
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    export default {
        components:{loadings, Swiper, SwiperSlide},
        data() {
            return {
                loading: true,
                pageData:{},
                root_url:VUE_URL_TASK_TEA,
                kz_root:VUE_URL_KZAPP,
                token:"",
                swiperOption:{
                    pagination:{
                        el:'.swiper-pagination',
                    },
                    loop:true,
                    autoplay:{
                        delay: 3000,    //秒
                        stopOnLastSlide: false,
                        disableOnInteraction: false,//滑动不会失效
                    },
                    speed:300,
                },
            }
        },
        created() {
			if (this.inApp) {
				this.appFunction("ys_finish");
				return
			}
            let user_id = localStorage.getItem("info") ? JSON.parse(localStorage.getItem("info")).user_id : 0;
            let is_show_modal = Number(sessionStorage.getItem("is_show_modal"))||0;
            this.token=localStorage.getItem("Tbkt-Token");
            if(user_id){
                this.$http.post(API_URL_CONFIG_API + '/api/new/home/extra/', {
                    user_id:user_id,
                    is_tea_new:1,
                    user_type:3,
                    is_show_modal:0
                }).then(res => {
                    res = res.data;
                    this.loading = false;
                    if (res.response == 'ok') {
                        if(!is_show_modal) sessionStorage.setItem("is_show_modal",1);
                        this.pageData = res.data;
                    } else {
                        layer.tips(res.message);
                    }
                });
            }
        },
        methods: {
            
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #app_index{
        min-height: calc(100vh - 2.4rem);
        box-sizing: border-box;
        padding-bottom: 32px/$ppr;
        background-color: #f5f6f7;
        .carousel{
            position: relative;
            background-image: linear-gradient(#fff,#f5f6f7);
            padding: 32px/$ppr 32px/$ppr 12px/$ppr;
            .carsousel_img {
                display: block;
                width: 100%;
            }
            .swiper-pagination{
                position: relative;
                display: flex;
                justify-content: center;
                padding: 12px/$ppr 0;
                /deep/.swiper-pagination-bullet{
                    width: 8px/$ppr;
                    height: 8px/$ppr;
                    background-color: #e5e5e5;
                    border-radius: 4px/$ppr;
                    opacity: 1;
                    &:not(:last-child){
                        margin-right: 4px/$ppr;
                    }
                    &.swiper-pagination-bullet-active{
                        background: #0097fe;
                        width: 16px/$ppr;
                    }
                }
            }
        }
        .center_content{
            margin: 16px/$ppr 32px/$ppr 40px/$ppr;
            display: flex;
            justify-content: space-between;
            .center_left,.center_right{
                width: 320px/$ppr;
                height: 376px/$ppr;
            }
            .center_left{
                background-image: linear-gradient(120deg,#fd7532,#ff4d36);
                padding-top: 20px/$ppr;
                display: flex;
                flex-direction: column;
                align-items: center;
                box-sizing: border-box;
                .teacher_img{
                    display: block;
                    width: 195px/$ppr;
                }
                .part_text{
                    line-height: 1;
                    font-size: 38px/$ppr;
                    margin-bottom: 14px/$ppr;
                }
                .pub_btn{
                    width: 148px/$ppr;
                    height: 48px/$ppr;
                    border-radius: 24px/$ppr;
                    background-color: transparent;
                    color: #fff;
                    border: 1px solid #fff;
                    text-align: center;
                    font-size: 24px/$ppr;
                }
            }
            .center_part{
                border-radius: 16px/$ppr;
                color: #fff;
                .part_text{
                    font-weight: bold;
                }
            }
            .center_right{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .center_part{
                    height: 114px/$ppr;
                    padding-left: 24px/$ppr;
                    position: relative;
                    .part_text{
                        padding-top: 15px/$ppr;
                        font-size: 34px/$ppr;
                        line-height: 49px/$ppr;
                    }
                    .part_label{
                        font-size: 22px/$ppr;
                        line-height: 37px/$ppr;
                    }
                    .part_icon{
                        position: absolute;
                        display: block;
                        width: 48px/$ppr;
                        right: 24px/$ppr;
                        bottom: 16px/$ppr;
                    }
                }
            }
        }
        .statistics_part{
            margin: 0 32px/$ppr;
            padding: 0 32px/$ppr 1px;
            background-color: #fff;
            border-radius: 16px/$ppr;
            .part_title{
                font-size: 36px/$ppr;
                font-weight: bold;
                line-height: 98px/$ppr;
            }
            .unit_lists{
                padding-top: 16px/$ppr;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .unit_item{
                    width: 260px/$ppr;
                    padding-left: 26px/$ppr;
                    border-radius: 12px/$ppr;
                    height: 160px/$ppr;
                    background-color: #f6f6ff;
                    display: flex;
                    align-items: center;
                    margin-bottom: 32px/$ppr;
                    .unit_icon{
                        display: block;
                        width: 54px/$ppr;
                        margin-right: 20px/$ppr;
                        flex-shrink: 0;
                    }
                    .unit_info{
                        flex-grow: 1;
                        .unit_name{
                            font-size: 30px/$ppr;
                            font-weight: bold;
                            line-height: 44px/$ppr;
                            color: #2e26a8;
                        }
                        .pub_line{
                            font-size: 24px/$ppr;
                            color: #6d6bc2;
                            line-height: 38px/$ppr;
                        }
                    }
                }
            }
        }
        .tea_cover{
            .active_modal{
                width: 600px/$ppr;
                height: 800px/$ppr;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -400px/$ppr;
                margin-left: -300px/$ppr;
                .model_img{
                    display: block;
                    width: 100%;
                    height: 100%;
                }
                .modal_close{
                    position: absolute;
                    width: 50px/$ppr;
                    height: 50px/$ppr;
                    right: 0;
                    top: -82px/$ppr;
                    background-size: 100% 100%;
                    background-image: url("./img/modal_close.png");
                }
            }
        }
    }
</style>